import { Controller } from "@hotwired/stimulus"
import debounce from "debounce";

// Connects to data-controller="auto-submit"
export default class extends Controller {
  initialize() {
    this.submitForm = debounce(this.submitForm, 500).bind(this);
  }

  submitForm(event) {
    this.element.requestSubmit()
  }
}
